import { render, staticRenderFns } from "./literature-folder.vue?vue&type=template&id=2fcbf05f&scoped=true&"
import script from "./literature-folder.vue?vue&type=script&lang=ts&"
export * from "./literature-folder.vue?vue&type=script&lang=ts&"
import style0 from "./literature-folder.vue?vue&type=style&index=0&id=2fcbf05f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcbf05f",
  null
  
)

export default component.exports